import { Component, computed, input, Input, InputSignal, Signal } from '@angular/core';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { CommonModule, DatePipe, NgIf } from '@angular/common';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import { LabelComponent } from '../../../../../common/label/label.component';
import { ParcelsPreviewComponent } from '../../common/components/parcels/parcels-preview/parcels-preview.component';
import {
  ApplicationAppEntityApplicationRead,
  ParcelAppEntityApplicationRead,
  ShipmentAppEntityShipmentRead
} from '../../../../../openapi';
import {
  ObjectNameOrAdvertisementDescLabelPipe
} from '../../../../../pipes/object-name-or-advertisement-desc-label.pipe';
import { DistanceLabelPipe } from '../../../../../pipes/distance-label.pipe';
import {
  ContractorDataPreviewComponent
} from '../../common/contractor-data-section/components/contractor-data-preview/contractor-data-preview.component';

@Component({
  selector: 'app-consent-location-of-buildings-smaller-distance-preview',
  standalone: true,
  imports: [
    AgreementsDataPreviewComponent,
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    DatePipe,
    DecisionDataPreviewComponent,
    LabelComponent,
    CommonModule,
    ParcelsPreviewComponent,
    ObjectNameOrAdvertisementDescLabelPipe,
    DistanceLabelPipe,
    ContractorDataPreviewComponent
  ],
  templateUrl: './consent-location-of-buildings-smaller-distance-preview.component.html'
})
export class ConsentLocationOfBuildingsSmallerDistancePreviewComponent {
  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public parcels: Signal<ParcelAppEntityApplicationRead[]> = computed(() => this.application()?.parcels?.filter(v => v?.tag === 'parcels') || []);

  public parcels2: Signal<ParcelAppEntityApplicationRead[]> = computed(() => this.application()?.parcels?.filter(v => v?.tag === 'parcels2') || []);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);
}
